module.exports = __webpack_public_path__ + "img/close_white.26b16320.svg";